
import React from 'react';
import moment from 'moment';


const SpecializationsWidget = ({data}) => (
    <table className="table">
        <thead>
        <tr>
            <th>Направление</th>
            <th>Всего мест</th>
            {!data.preparing_results&&!data.results_ready
            ?<React.Fragment>
                <th>Место среди всех</th>
                <th>Место среди сдавших</th>
            </React.Fragment>
            :null}
            {data.results_ready?<th>Результат</th>:null}
        </tr>
        </thead>
        <tbody>
        {_.map(
            data.specializations,
            (v, k) => <tr key={k}><SpecializationWidget root={data} data={v} /></tr>
        )}
        </tbody>
    </table>
)


const SpecializationWidget = ({root, data, hide}) => (
    <React.Fragment>
        <td>
            {data.code} {data.short_name}
        </td>
        <td>{data.grading_total||"-"}</td>
        {!data.preparing_results&&!data.results_ready
        ?<React.Fragment>
            <td>{data.grading||"-"}</td>
            <td>{data.grading_real||"-"}</td>
        </React.Fragment>
        :null}
        {data.results_ready
        ?<td>
            {data.recommended
            ?<strong className="text-success">Рекомендован к зачислению</strong>
            :null}
        </td>
        :null}
    </React.Fragment>
);

const TaskWidget = ({data}) => (
    <React.Fragment>
        {data.type_name}
        &nbsp;
        {data.is_completed
            ?<React.Fragment>
                <i className="bi bi-check text-success"/>
                <small className="text-success">выполнено {moment(data.completed_at).format('DD.MM.YYYY')}</small>
            </React.Fragment>
            :<React.Fragment>
                <i className="bi bi-exclamation text-danger"/>
                <small className="text-danger">
                    не выполнено
                    {data.planned_at?<React.Fragment>, запланировано на {moment(data.planned_at).format('DD.MM.YYYY HH:mm')}</React.Fragment>:null}
                </small>
            </React.Fragment>
        }
        {data.description
        ? <div className="text-secondary text-small" dangerouslySetInnerHTML={{__html:data.description}}/>
        : null}

    </React.Fragment>
);

const AttachmentWidget = ({data}) => (
    <React.Fragment>
        {!data.req_original
            ?<i className="bi bi-copy text-success" />
            :<i className="bi bi-copy text-danger" />
        }
        &nbsp;
        {data.req_for_grading
            ?<i className="bi bi-journal-medical text-warning" />
            :<i className="bi bi-journal-check text-success" />
        }
        &nbsp;
        {data.type_name}
        &nbsp;
        {data.is_attached
            ?<small className="text-success">{data.state}</small>
            :<small className="text-danger">{data.state}</small>
        }
        
    </React.Fragment>
)

const StatusWidget = ({data}) => (
    <React.Fragment>
        <h5>Общие сведения</h5>

        <ul>
            <li>
                Статус заявления: {data.status_name}
            </li>
            <li>
                {data.grading_allowed
                    ?<span className="text-success">Соответствует</span>
                    :<span className="text-danger">Не сооветствует</span>
                }
                &nbsp;
                условиям участия в рейтинге
            </li>
            <li>
                Средний балл аттестата: {data.edu_avg_grade}
            </li>
            <li>
                Сумма баллов по приоритетным предметам: {data.edu_prio_subj_grade_sum}
            </li>
        </ul>

        <h5>Направления</h5>
        <SpecializationsWidget data={data} />

        <h5>Задачи <span className="text-secondary">({data.completed_task_count}/{data.total_task_count})</span></h5>

        <ul>
            {_.map(
                data.tasks,
                (v, k) =>
                    <li key={k}>
                        <TaskWidget key={k} data={v} />
                    </li>
            )}
        </ul>

        <h5>Вложения</h5>

        <ul>
            {_.map(
                data.attachments,
                (v, k) =>
                    <li key={k}>
                        <AttachmentWidget key={k} data={v} />
                    </li>
            )}
        </ul>
    </React.Fragment>    
);


const ResultsWidget = ({data}) => {
    const
        any_recommended = _.reduce(
            data.specializations,
            (r, v) => r|v.recommended,
            false
        )

    return (
        <React.Fragment>
            {(data.preparing_results)
                ?<div className="card border-warning mb-2">
                    <div className="card-header text-bg-warning">
                        Подведение итогов
                    </div>
                    <div className="card-body">
                        В данный момент ведётся подведение итогов работы приёмной комиссии
                    </div>
                </div>
                :null}

            {(data.results_ready&&!any_recommended)
                ?<div className="card border-warning mb-2">
                    <div className="card-header text-bg-warning">
                        Подведение итогов завершено
                    </div>
                    <div className="card-body">
                        Подведение итогов работы приёмной комиссии завершено.
                        Уточнить результаты вы можете обратившись
                        в приёмную комиссию лично или по телефону <a href="tel:+73412432388">(3412) 43-23-88</a>.
                    </div>
                </div>
            :null}
            {(data.results_ready&&any_recommended)
            ?<div className="card border-success mb-2">
                <div className="card-header text-bg-success">
                    Вы рекомендованы к зачислению
                </div>
                <div className="card-body">
                    Подведение итогов работы приёмной комиссии завершено &mdash; вы рекомендованы
                    к зачислению.
                </div>
            </div>
            :null}
        </React.Fragment>
    );
}


export default ({uid, data}) => (
    <React.Fragment>
        <ResultsWidget data={data} />

        <div className="card border-secondary mb-2">
            <div className="card-header text-bg-secondary">Статус заявления</div>
            <div className="card-body">
                <StatusWidget data={data} />
            </div>
        </div>
    </React.Fragment>
);

